module.exports = __webpack_public_path__ + "static/media/Pirate600_3c.fb89a488.svg";